import {useCallback, useState} from 'react';

/**
 * @typedef {Object} shownState
 * @property {boolean} shown - boolean that will change
 * @property {function} onClick - callback to change `shown` to `true`
 * @property {function} onClose - callback to change `shown` to `false`
 * @property {function} onToggle - callback to toggle `shown`
 */
type UseShown = (
    defaultState?: boolean
) => {
    shown: boolean,
    onClick: () => void,
    onClose: () => void,
    onToggle: () => void,
};

/**
 * Returns a boolean value and callbacks to change it
 * @param {boolean} defaultState - default value for boolean value
 * @return {shownState}
 */
export const useShown: UseShown = (defaultState = false) => {
    const [shown, setShown] = useState<boolean>(defaultState);
    const onClick = useCallback(() => {
        setShown(true);
    }, []);
    const onClose = useCallback(() => {
        setShown(false);
    }, []);
    const onToggle = useCallback(() => {
        setShown(state => !state);
    }, []);
    return {
        shown,
        onClick,
        onClose,
        onToggle,
    };
};
